import { getApiBaseUrl } from '../utils/config';

export interface PublicWaitingStatus {
  storeName: string;
  currentWaiting: number;
  currentCalled: number;
  lastCalledNumber: number;
  nextWaitingNumber: number;
  estimatedWaitMinutes: number;
  takeoutWaiting: number;
  takeoutEstimatedMinutes: number;
  isAcceptingNow: boolean;
  closedReason: string | null;
  closedMessage: string | null;
  updatedAt: string;
}

/**
 * 공개 대기 현황 조회 (인증 불필요)
 */
export async function getPublicStatus(
  storeId: string,
): Promise<PublicWaitingStatus> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/api/stores/${encodeURIComponent(storeId)}/waitings/public`;

  const response = await fetch(url);
  const json = await response.json();

  if (!response.ok || !json.success || !json.data) {
    throw new Error(json.error ?? '대기 현황을 불러올 수 없습니다.');
  }

  return json.data as PublicWaitingStatus;
}
